import { render, staticRenderFns } from "./Userchange.vue?vue&type=template&id=5fee3e2a&scoped=true"
import script from "./Userchange.vue?vue&type=script&lang=js"
export * from "./Userchange.vue?vue&type=script&lang=js"
import style0 from "./Userchange.vue?vue&type=style&index=0&id=5fee3e2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fee3e2a",
  null
  
)

export default component.exports